import { computed, ref, watch } from "vue";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useNgSession } from "@sazka/ng/ng-session";
import { logException } from "@sazka/utils/logger/use-app-logger";
import { fethGwPlayerStatus } from "@/loyalty/api/loyalty-api";
import { GwPlayerStatus } from "@/loyalty/api/models/gw-player-status";

const { session, isLoggedIn } = useNgSession();
const playerId = computed(() => session.value?.PlayerID);

const maxGwPoints = 10;

const gwPlayerData = ref<GwPlayerStatus>({
    points: 0,
    access: { denied: true, reason: null },
    lastPointsChange: 0,
    hasBonusWheel: false,
    receivedCampaignPoints: false,
});
const hasMaxPoints = computed(() => gwPlayerData.value?.points >= maxGwPoints);

const isGwPlayerDataLoaded = ref(false);
const isGwPlayerDataLoadingError = ref(false);

async function loadGwPlayerData() {
    try {
        const prevPointsCache = gwPlayerData.value.points;

        gwPlayerData.value = await fethGwPlayerStatus(playerId.value);
        gwPlayerData.value.lastPointsChange = gwPlayerData.value.points - prevPointsCache;
        isGwPlayerDataLoadingError.value = false;
        isGwPlayerDataLoaded.value = true;
    } catch (err) {
        logException("golden-wheel-player", err, { message: "Load player data error" });
        isGwPlayerDataLoadingError.value = true;
    }
}

function updateGwPoints(newPoints: number) {
    gwPlayerData.value.lastPointsChange = newPoints - gwPlayerData.value.points;
    gwPlayerData.value.points = newPoints;
}

function updateGwData(newPoints: number, denied: boolean, hasBonusWheel: boolean, receivedCampaignPoints: boolean) {
    gwPlayerData.value.points = newPoints;

    gwPlayerData.value.access.denied = denied;
    gwPlayerData.value.hasBonusWheel = hasBonusWheel;
    gwPlayerData.value.receivedCampaignPoints = receivedCampaignPoints;
}

async function initGwPlayerStatus() {
    await ngFrameworkLoaded();

    watch(
        isLoggedIn,
        async (newIsLoggedIn) => {
            if (newIsLoggedIn) {
                await loadGwPlayerData();
            } else {
                isGwPlayerDataLoaded.value = false;
            }
        },
        { immediate: true }
    );
}

export default {
    isGwPlayerDataLoaded,
    isGwPlayerDataLoadingError,
    gwPlayerData,
    hasMaxPoints,
    maxGwPoints,

    initGwPlayerStatus,
    loadGwPlayerData,
    updateGwPoints,
    updateGwData,
};
